import { createFileRoute, getRouteApi, useRouter } from '@tanstack/react-router';
import { useMutation } from '@tanstack/react-query';
import { t } from '@lingui/core/macro';
import AuthorizedApplications from '@/components/Settings/AuthorizedApplications';
import { settingsService } from '@/services/settings';
import { useToast } from '@/hooks/useToast';

const settingsRoute = getRouteApi('/_app/settings');

export const Route = createFileRoute('/_app/settings/applications')({
  component: ApplicationsPage,
});

function ApplicationsPage() {
  const router = useRouter();
  const settings = settingsRoute.useLoaderData();
  const { showToast } = useToast();

  const revokeMutation = useMutation({
    mutationFn: (consumerId: number) =>
      settingsService.revokeAuthorizedApplication(consumerId, settings.user.formKey),
    onSuccess: async () => {
      showToast(t`Application access revoked`, 'success');
      await router.invalidate();
    },
    onError: (error) => {
      showToast(
        error instanceof Error
          ? error.message
          : t`Sorry, there was an error. Please try again.`,
        'error',
      );
    },
  });

  return (
    <AuthorizedApplications
      applications={settings.authorizedApplications}
      onRevoke={(consumerId) => revokeMutation.mutate(consumerId)}
      revokingApplicationId={
        revokeMutation.isPending ? revokeMutation.variables : undefined
      }
    />
  );
}
